__turbopack_context__.v({
  "carouselArrows": "gameCard-module-scss-module__tJheha__carouselArrows",
  "centerTitle": "gameCard-module-scss-module__tJheha__centerTitle",
  "leftArrow": "gameCard-module-scss-module__tJheha__leftArrow",
  "rightArrow": "gameCard-module-scss-module__tJheha__rightArrow",
  "slider": "gameCard-module-scss-module__tJheha__slider",
  "title": "gameCard-module-scss-module__tJheha__title",
  "wrapperFirstRow": "gameCard-module-scss-module__tJheha__wrapperFirstRow",
  "wrapperSecondRow": "gameCard-module-scss-module__tJheha__wrapperSecondRow",
});
